import { useState } from 'react';

function useTabs(initialTabIndex = 0) {
    const [activeTab, setActiveTab] = useState(initialTabIndex);

    const changeTab = (index) => {
        setActiveTab(index);
    };

    return {
        activeTab,
        changeTab,
    };
}

export default useTabs;
